export const ENV: API_ENV = import.meta.env.VITE_APP_ENV || 'test'
